import { render, staticRenderFns } from "./InstagramSettingsCard.vue?vue&type=template&id=09a5834c"
import script from "./InstagramSettingsCard.vue?vue&type=script&lang=ts"
export * from "./InstagramSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports